import React from 'react';
import clsx from 'clsx';

import './index.scss';

const RadioInputWithIcon = ({ value, onChange, icon, checked, label, subLabel, id }) => {
  const svgDir = require.context("!@svgr/webpack!assets/");

  const Icon = checked ? svgDir(`./${icon}_blue.svg`).default : svgDir(`./${icon}.svg`).default;

  return (
    <>
      <label htmlFor={id}>
        <div className={clsx('RadioInputWithIcon', { checked })}>
          <div className='radio-input-wrapper'>
            <div className="radioIcon">
              <input
                className='radio-input'
                type="radio"
                value={value}
                onChange={onChange}
                checked={checked}
                id={id}
              />
            </div>
            <div className="RadioInputWithIcon.label">
              <span className="">
                {
                  Array.isArray(label)
                    ? label.map(line => (
                      (
                        <span key={line}>
                          {line}
                          <br />
                        </span>
                      )
                    ))
                    : 
                    label
                }
              </span>
              <span className="subLabel">
                {
                  Array.isArray(subLabel)
                    ? subLabel.map(line => (
                      (
                        <span key={line}>
                          {line}
                          <br />
                        </span>
                      )
                    ))
                    : 
                    subLabel
                }
              </span>
            </div>
          </div>
          <div className="iconArea">
            <div className="icon">
              <Icon />
            </div>
          </div>
        </div>
      </label>
    </>
  );
};

export default RadioInputWithIcon;